<template>
  <div class="container-fluid h-100">
    <div class="content-register" id="content1-register">
      <div class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100">
        <div id="title_404" class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
          <h2 class="club">Parece que la URL que ingresaste hay que llevarla <br> al mecánico a reparar</h2>
        </div>
        <br>
        <div class="btn_ir_inicio" style="margin:200px auto auto auto;">
          <button id="btn_ir_inicio" @click="irRedirection()">
            CLICK PARA IR <br> AL CATÁLOGO DEL MOTOCLUB
          </button>
          <br><br>
          <p class="comprobar"><strong>Comprueba que esté bien escrita<br>o ve al </strong><strong style="color:yellow; cursor:pointer;" @click="irRedirection()">catálogo del motoclub</strong></p>
        </div>
      </div>
    </div>
    <!-- <footerLanding/> -->
  </div>
</template>

<script>
// import footerLanding from "./../../components/footerLanding.vue";

export default {
  name: "404",
  
  asyncData({ res }) {
    res.statusCode = 404;
  },
  data() {
    return {
    };
  },
  watch: {},
  methods: {
    irRedirection(){
      this.$router.push({ name: "catalogue" });
    }
  },
  mounted() {}
};
</script>

<style scoped>
#title_404{
  margin-top:-110px;
}
#btn_ir_inicio{
  background-color: red;
  font-weight: bold;
  border-radius: 150px;
  padding: 5px 30px 5px 30px;
  border: none;
  color: white;
  box-shadow: 0 0 0 8px black, 0 0 0 10px white;
  font-size: 10px;
}
.comprobar{
  font-size: 20px;
}
.content-register {
  padding-left: 5%;
  padding-top: 14%;
  padding-bottom: 20%;
  height: 100%;
}
.club {
  font-size: 30px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: center;
}
.ingresa {
  font-size: 22px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/image_404.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
  height: 100vh;
}

.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.condiciones {
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
/* .fa {
  color: #fff;
} */

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .content-register {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-register {
    height: 100%;
  }
  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .content-register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }
  .club {
    font-size: 15px;
    text-align: left;
  }
  .ingresa {
    font-size: 20px;
    text-align: left;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
}

@media (max-width: 480px) {
  #content1-register {
    background-size: contain;
    background-image: url("../../assets/img/image_404_mobile.png");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
    height: 100vh;
  }
  .club {
    font-size: 16px;
    text-align: center !important;
  }
  .comprobar {
    margin-top: 15px;
    font-size: 15px;
  }
  .btn_ir_inicio{
    margin-top: 250px !important;
  }
  #title_404{
    margin-top:-50px;
  }
}
</style>
